module.exports = __webpack_public_path__ + "static/petra_character_wishmastree_01-07cf06702b7dc44970210e466e29d723.jpg";